import { useCallback } from 'react';
import { PolicyHandler, executePolicyHandler } from '@open-commerce/oc-authorization-policies';

import { useAbilityContext } from './use-ability-context.hook';

type PolicyInputValues = {
  uuid?: string;
  [key: string]: unknown;
};

export const useCan = () => {
  const abilities = useAbilityContext();

  return useCallback(
    (handler: PolicyHandler, inputValues?: PolicyInputValues) =>
      executePolicyHandler(handler, abilities, inputValues),
    [abilities],
  );
};
